/*
 * Shared form validation (same behaviour as the reseller form,
 * sections/reseller-signup.liquid): on submit, every invalid field gets a
 * red outline + a message under it, a summary shows up, the page scrolls to
 * the first problem, and each error clears as soon as that field is fixed.
 *
 * Opt-in markup:
 *   <form data-validate novalidate>           the form to validate
 *     <div data-validate-field>               one field (gets .is-invalid + the message)
 *       <label>…</label>
 *       <div data-validate-box>…<input required></div>   the outlined box
 *     </div>
 *   </form>
 *   <p data-form-error hidden></p>            optional summary, inside the form
 *                                             or right after it
 *
 * A field that is itself the box (data-validate-field + data-validate-box on
 * the same element, e.g. an email pill next to a button) gets no inline
 * message — the summary carries it instead.
 *
 * Validated on the submit button's click (capture) as well as on submit:
 * Shopify's hCaptcha on native forms can call form.submit() straight from the
 * click, which never fires the 'submit' event.
 */
(function () {
  if (window.NovvoFormValidation) return;

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var CONTROLS = 'input:not([type="hidden"]):not([type="submit"]):not([type="button"]), select, textarea';

  function messageFor(control) {
    if (control.disabled) return '';
    var value = (control.value || '').trim();

    if (control.type === 'checkbox') {
      return control.required && !control.checked ? 'Marque esta opção para continuar.' : '';
    }
    if (control.tagName === 'SELECT') {
      return control.required && !control.value ? 'Selecione uma opção.' : '';
    }
    if (control.required && !value) return 'Preencha este campo.';
    if (control.type === 'email' && value && !EMAIL.test(value)) return 'Digite um e-mail válido.';
    return '';
  }

  function fieldOf(control) {
    return control.closest('[data-validate-field]') || control.parentElement;
  }

  function summaryOf(form) {
    var summary = form.querySelector('[data-form-error]');
    if (summary) return summary;
    var next = form.nextElementSibling;
    return next && next.hasAttribute('data-form-error') ? next : null;
  }

  function setFieldError(field, message) {
    field.classList.toggle('is-invalid', !!message);

    var error = null;
    for (var i = 0; i < field.children.length; i++) {
      if (field.children[i].classList.contains('form-field-error')) error = field.children[i];
    }

    // The field is the outlined box itself: no room for an inline message.
    if (field.hasAttribute('data-validate-box') || !message) {
      if (error) error.remove();
      return;
    }
    if (!error) {
      // <span>, not <p>: some fields are <label>s.
      error = document.createElement('span');
      error.className = 'form-field-error';
      field.appendChild(error);
    }
    error.textContent = message;
  }

  function validate(form) {
    var invalid = [];
    var seen = [];

    form.querySelectorAll(CONTROLS).forEach(function (control) {
      var field = fieldOf(control);
      if (!field || seen.indexOf(field) !== -1) return;
      // Hidden fields (e.g. an inactive view) aren't validated.
      if (!field.offsetParent && field.getClientRects().length === 0) return;
      seen.push(field);

      var message = messageFor(control);
      setFieldError(field, message);
      if (message) invalid.push({ field: field, message: message });
    });

    var summary = summaryOf(form);
    if (!invalid.length) {
      if (summary) summary.hidden = true;
      return true;
    }

    if (summary) {
      var first = invalid[0];
      if (invalid.length === 1) {
        summary.textContent = first.field.hasAttribute('data-validate-box')
          ? first.message
          : 'Falta 1 campo: confira o item destacado em vermelho.';
      } else {
        summary.textContent = 'Faltam ' + invalid.length + ' campos: confira os itens destacados em vermelho.';
      }
      summary.hidden = false;
    }

    var target = invalid[0].field;
    var details = target.closest('details');
    if (details) details.open = true;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var focusable = target.querySelector('[data-select-trigger]') || target.querySelector(CONTROLS);
    if (focusable && focusable.focus) focusable.focus({ preventScroll: true });
    return false;
  }

  function clearFor(control) {
    if (!control || !control.closest) return;
    var form = control.closest('form[data-validate]');
    if (!form) return;
    var field = fieldOf(control);
    if (!field || !field.classList.contains('is-invalid')) return;
    if (!messageFor(control)) setFieldError(field, '');

    if (!form.querySelector('.is-invalid')) {
      var summary = summaryOf(form);
      if (summary) summary.hidden = true;
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button[type="submit"], input[type="submit"], button:not([type])');
    var form = button && button.form;
    if (!form || !form.hasAttribute('data-validate')) return;
    if (!validate(form)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.hasAttribute || !form.hasAttribute('data-validate')) return;
    if (!validate(form)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  // <form data-submit-once>: native POSTs that reload the page (e.g. add to
  // cart) take a moment — ignore extra clicks after the first valid submit.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.hasAttribute || !form.hasAttribute('data-submit-once') || event.defaultPrevented) return;
    if (form.dataset.submitting) {
      event.preventDefault();
      return;
    }
    form.dataset.submitting = 'true';
    form.querySelectorAll('[type="submit"], button:not([type])').forEach(function (button) {
      button.classList.add('is-loading');
    });
  });
  // Back button restoring the page from the bfcache: unlock again.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('form[data-submit-once][data-submitting]').forEach(function (form) {
      delete form.dataset.submitting;
      form.querySelectorAll('.is-loading').forEach(function (el) { el.classList.remove('is-loading'); });
    });
  });

  document.addEventListener('input', function (event) { clearFor(event.target); });
  document.addEventListener('change', function (event) { clearFor(event.target); });

  window.NovvoFormValidation = { validate: validate };
})();
